import React, { useState, useEffect } from "react";

import { DetailsAvailabilityList } from "./DetailsAvailabilityList";
import MakeAvailableModal from "./MakeAvailableModal";

export default function AvailabilityListManager({
  interviewId,
  translator,
  InterviewSkills,
  AvailabilitiesListService,
  email,
  generatedDocOlineLanguageId,
  setAvailabilityStatus,
  setIsOpen,
  isOpen
}) {
  const [availabilityList, setAvailabilityList] = useState({});
  const [contractTypes, setContractTypes] = useState([]);

  const [docStatusLabel, setDocStatusLabel] = useState({});
  const [docStatus, setDocStatus] = useState();
  const [error, setError] = useState({});
  const AVAILABILITYTYPE = { immediate: 1, fixedDate: 2, preNotice: 3 };
  useEffect(() => {
    if (interviewId) {
      AvailabilitiesListService.getAvailabilityList(interviewId).then(
        (data) => {
          processResponse(data);
        }
      );
    }

    AvailabilitiesListService.getContractTypes().then((data) => {
      if (!data.error) setContractTypes(data);
    });
  }, [interviewId]);
  function validate() {
    let _error = {};
    if (!availabilityList.skills) {
      _error.skills = translator("Skills is required");
    }
    if (!availabilityList.availabilityType) {
      _error.availabilityType = translator("Availability is required");
    }
    if (availabilityList.availabilityType === AVAILABILITYTYPE.fixedDate) {
      if (!availabilityList.availabilityDate) {
        _error.availabilityDate = translator("Availability date is required");
      }
    }
    if (availabilityList.availabilityType === AVAILABILITYTYPE.preNotice) {
      if (!availabilityList.numberOfWeeks) {
        _error.numberOfWeeks = translator("Number of weeks is required");
      }
    }
    if (!availabilityList.userContractTypeId) {
      _error.userContractTypeId = translator("Contract type is required");
    }
    setError(_error);
    if (Object.keys(_error).length > 0) {
      return false;
    }

    return true;
  }
  function processResponse(data) {
    if (data.availabilitiesList) {
      setAvailabilityList({
        ...data.availabilitiesList,
        generatedDocOlineLanguageId,
        email,
        interviewId
      });
    } else {
      setAvailabilityList({
        email,
        skills: InterviewSkills,
        interviewId,
        generatedDocOlineLanguageId
      });
    }
    setAvailabilityStatus(data.availabilitiesList != null);
    setDocStatus(data.docStatus);
    setDocStatusLabel(data.docStatusLabel);
  }
  return (
    <>
      {availabilityList.availabilityId && (
        <DetailsAvailabilityList
          availabilityList={availabilityList}
          t={translator}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          docStatus={docStatus}
          docStatusLabel={docStatusLabel}
          setAvailabilityList={setAvailabilityList}
          AvailabilitiesListService={AvailabilitiesListService}
          error={error}
          validate={validate}
          processResponse={processResponse}
          contractTypes={contractTypes}
        />
      )}

      {!availabilityList.availabilityId && (
        <MakeAvailableModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          translator={translator}
          availabilityList={availabilityList}
          setAvailabilityList={setAvailabilityList}
          AvailabilitiesListService={AvailabilitiesListService}
          docStatus={docStatus}
          docStatusLabel={docStatusLabel}
          error={error}
          validate={validate}
          processResponse={processResponse}
          contractTypes={contractTypes}
        />
      )}
    </>
  );
}
